import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import jwt_decode from "jwt-decode" ;

import { Chart } from "chart.js";
import Toasted from "vue-toasted";
import Vuelidate from 'vuelidate';
import Chartkick from "vue-chartkick";
import { BootstrapVue } from 'bootstrap-vue'
import VueSweetalert2 from 'vue-sweetalert2';
import "admin-lte/build/js/AdminLTE";
import "admin-lte/plugins/jquery/jquery";
import 'bootstrap/dist/css/bootstrap.css';
import "admin-lte/dist/css/adminlte.min.css";
import 'sweetalert2/dist/sweetalert2.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import "admin-lte/plugins/bootstrap/js/bootstrap";
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import vueCountryRegionSelect from 'vue-country-region-select'
import 'vue-multiselect/dist/vue-multiselect.min.css'

import interceptorsSetup from './services/InterceptorSetup'

import AutoLogout from '@/components/organisms/AutoLogout.vue'

interceptorsSetup(store)

let token = localStorage.getItem('token')
if (token != null) {
  let access_token = jwt_decode(token)
  Vue.prototype.$user_id = access_token.user_id
}

Vue.component('auto-logout', require('./components/organisms/AutoLogout.vue').default);
Vue.use(VueTelInput);
Vue.config.productionTip = false;
Vue.use(Chartkick.use(Chart));
Vue.use(Toasted);
Vue.use(VueSweetalert2);
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(AutoLogout)
Vue.use(vueCountryRegionSelect)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
